import { deDE, enUS, esES, frFR, svSE } from "@mui/x-date-pickers/locales/";
import { Domains } from "@/core/types/types";

type TranslationsMap = {
  [key in Domains | string]: object;
};

interface TranslationParams {
  digitAmount: number;
  contentType: string;
}

const missingTranslations: TranslationsMap = {
  [Domains.ES]: {
    fieldYearPlaceholder: (params: TranslationParams) =>
      "A".repeat(params.digitAmount),
  },
  [Domains.SE]: {
    fieldYearPlaceholder: (params: TranslationParams) =>
      "Å".repeat(params.digitAmount),
  },
};

const translations: TranslationsMap = {
  [Domains.UK]: enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.NET]:
    enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.COM]:
    enUS.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.DE]: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.AT]: deDE.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.ES]: {
    ...esES.components.MuiLocalizationProvider.defaultProps.localeText,
    ...missingTranslations[Domains.ES],
  },
  [Domains.FR]: frFR.components.MuiLocalizationProvider.defaultProps.localeText,
  [Domains.SE]: {
    ...svSE.components.MuiLocalizationProvider.defaultProps.localeText,
    ...missingTranslations[Domains.SE],
  },
};

const getTranslationTexts = (tld: string): object => translations[tld];

export default getTranslationTexts;
